import { Chip, styled } from "@mui/material";

import { TagColor } from "fond/utils/colors";

export const TagChip = styled(Chip, { shouldForwardProp: (prop) => prop !== "tagColor" })<{ tagColor?: TagColor }>(({ theme, tagColor }) => ({
  height: 22,
  fontSize: theme.typography.size.xsmall,
  fontWeight: 600,
  backgroundColor: tagColor?.bg ?? theme.palette.grey[100],
  color: tagColor?.text ?? theme.palette.text.secondary,
}));
